export const GET_DEFAULT_COURSES_REQUEST = 'GET_DEFAULT_COURSES_REQUEST';
export const GET_DEFAULT_COURSES_SUCCESS = 'GET_DEFAULT_COURSES_SUCCESS';
export const GET_DEFAULT_COURSES_FAILURE = 'GET_DEFAULT_COURSES_FAILURE';

export const getDefaultCourses = productId =>
    ({ type: GET_DEFAULT_COURSES_REQUEST, productId });

export const getDefaultCoursesSuccess = courses =>
    ({ type: GET_DEFAULT_COURSES_SUCCESS, courses });

export const getDefaultCoursesFailure = () =>
    ({ type: GET_DEFAULT_COURSES_FAILURE });

export const APPLY_SEARCH_FILTER = 'APPLY_SEARCH_FILTER';

export const applySearchFilter = (label, value) =>
    ({ type: APPLY_SEARCH_FILTER, label, value });

export const RESET_SEARCH_FILTER = 'RESET_SEARCH_FILTER';

export const resetSearchFilter = () =>
    ({ type: RESET_SEARCH_FILTER });

export const FILTER_DEFAULT_COURSES = 'FILTER_DEFAULT_COURSES';
export const FILTER_DEFAULT_SUCCESS = 'FILTER_DEFAULT_SUCCESS';

export const filterDefaultCourses = () =>
    ({ type: FILTER_DEFAULT_COURSES });

export const filterDefaultCoursesSuccess = filteredCourses =>
    ({ type: FILTER_DEFAULT_SUCCESS, filteredCourses });

export const ARCHIVE_SELECTED_COURSE_REQUEST = 'ARCHIVE_SELECTED_COURSE_REQUEST';
export const ARCHIVE_SELECTED_COURSE_FAILURE = 'ARCHIVE_SELECTED_COURSE_FAILURE';

export const archiveSelectedCourse = ({ productId, courseId, courseVersion }) =>
    ({ type: ARCHIVE_SELECTED_COURSE_REQUEST, productId, courseId, courseVersion });

export const archiveSelectedCourseSuccess = productId =>
    ({ type: GET_DEFAULT_COURSES_REQUEST, productId });

export const archiveSelectedCourseFailure = () =>
    ({ type: ARCHIVE_SELECTED_COURSE_FAILURE });



// WEBPACK FOOTER //
// ./app/containers/default-courses/actions.js